import { Skeleton } from "src/atoms/Skeleton";
import {
  ProductSuggestionsWrapper,
  ResultHeaderWrapper,
  ResultsContent,
  SearchResultContentContainer,
  SuggestionItemWrapper,
  SuggestionListWrapper,
} from "../SearchResults.styled";

const SUGGESTION_WIDTHS = [160, 120, 200, 140, 180];
const PRODUCT_COUNT = 6;

function SearchResultsSkeleton() {
  return (
    <SearchResultContentContainer>
      <ResultsContent>
        <SuggestionListWrapper>
          {SUGGESTION_WIDTHS.map((width, i) => (
            <SuggestionItemWrapper key={i}>
              <Skeleton width={width} height={16} />
            </SuggestionItemWrapper>
          ))}
        </SuggestionListWrapper>

        <ProductSuggestionsWrapper>
          <ResultHeaderWrapper>
            <Skeleton width={80} height={20} />
            <Skeleton width={100} height={14} />
          </ResultHeaderWrapper>

          <div className="products-suggestion-list-wrapper">
            {Array.from({ length: PRODUCT_COUNT }, (_, i) => (
              <div key={i}>
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    paddingTop: "150%",
                  }}
                >
                  <div style={{ position: "absolute", inset: 0 }}>
                    <Skeleton width="100%" height="100%" />
                  </div>
                </div>
                <Skeleton width={75} height={20} style={{ marginTop: 16 }} />
                <Skeleton width={180} height={17} style={{ marginTop: 4 }} />
                <Skeleton width={150} height={21} style={{ marginTop: 4 }} />
              </div>
            ))}
          </div>
        </ProductSuggestionsWrapper>
      </ResultsContent>
    </SearchResultContentContainer>
  );
}

export { SearchResultsSkeleton };
